import React from 'react';
import { Link } from 'react-router-dom';

// Hover colours are set explicitly: rendered as <a> (Link), Bootstrap's `a:hover` (0,1,1) would
// otherwise beat a plain tw-text-* class (0,1,0).
const VARIANTS = {
    primary: 'tw-bg-brand-600 tw-text-white hover:tw-bg-brand-700 hover:tw-text-white',
    outline: 'tw-border tw-border-neutral-300 tw-bg-white tw-text-neutral-700 hover:tw-bg-neutral-50 hover:tw-text-neutral-900',
    // Brand-coloured outline (Send reminder in the design).
    accent: 'tw-border tw-border-brand-600 tw-bg-white tw-text-brand-600 hover:tw-bg-brand-50 hover:tw-text-brand-700',
    // Near-black, the old UI's `btn-dark` (product Payment History).
    dark: 'tw-bg-neutral-800 tw-text-white hover:tw-bg-neutral-900 hover:tw-text-white',
};

// Separate from BASE so a size never meets a conflicting text/padding class (Tailwind would pick
// whichever it generated last, not the one written last).
const SIZES = {
    md: 'tw-px-3 tw-py-1.5 tw-text-sm',
    sm: 'tw-px-2.5 tw-py-1 tw-text-xs',
};

const BASE = 'tw-inline-flex tw-items-center tw-justify-center tw-gap-1.5 tw-whitespace-nowrap tw-rounded-md tw-font-medium focus:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-brand-300 disabled:tw-cursor-not-allowed disabled:tw-opacity-60';

/** Card-level button. A router <Link> when given `to`, otherwise a <button>. */
const ActionButton = ({ variant = 'outline', size = 'md', icon: Icon, to, onClick, disabled, children, className = '' }) => {
    const classes = `${BASE} ${SIZES[size]} ${VARIANTS[variant]} ${className}`;
    const content = <>
        {Icon ? <Icon className="tw-h-4 tw-w-4" aria-hidden="true" /> : null}
        {children}
    </>;

    return to
        ? <Link to={to} className={classes}>{content}</Link>
        : <button type="button" onClick={onClick} disabled={disabled} className={classes}>{content}</button>;
};

export default ActionButton;
